import axios from 'axios';
// import store from '../store/store';
// import { accessToken } from '../auth';

const api = axios.create ({
    baseURL: 'https://registrospromocionales.com.ar/api/',
    
    // baseURL: 'http://localhost:5000/api/',
});

// api.interceptors.request.use(function(config) {
//     // const token = store.getters['user/tokenString'];
//     let token = accessToken();

//     if(token) {
//         config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
// }, function(err) {
//     return Promise.reject(err);
// });

export default api;


// WEBPACK FOOTER //
// ./src/services/apiAxios.js